import script from "./UserGoods.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserGoods.vue?vue&type=script&setup=true&lang=ts"

import "./UserGoods.vue?vue&type=style&index=0&id=322f0fca&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322f0fca"]])

export default __exports__